import React, { Component } from 'react';
import {
  Container,
  Title,
  Text,
  ContentContain,
  InnerContain
} from './ErrorBoundaryStyled';

import Card from 'components/common/Card';
import MaterialIcon from 'material-icons-react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch() {
    //TODO log error
  }

  render() {
    if (this.state.hasError) {
      return (
        <Container>
          <InnerContain>
            <Card.Content>
              <ContentContain>
                <MaterialIcon
                  size={80}
                  icon="warning"
                  color={'rgba(211, 218, 221, 0.52)'}
                />
                <Title>Something Went Wrong!</Title>
                <Text>
                  An error has occurred. Please try refreshing the page, if you see
                  this error again the page may be unavailable and we are working on
                  the problem. Thank you for your patience.
                </Text>
              </ContentContain>
            </Card.Content>
          </InnerContain>
        </Container>
      );
    }

    return this.props.children;
  }
}

export const withErrorBoundary = (Component) =>
  function WrapperComponent(props) {
    return (
      <ErrorBoundary>
        <Component {...props} />
      </ErrorBoundary>
    );
  };
